<template>
<v-layout align-center justify-center row fill-height>
    <v-card>
        <v-card-title>
            <v-progress-circular indeterminate></v-progress-circular>
            <span class="spinnerText">Logging In...</span>
        </v-card-title>
    </v-card>
</v-layout>
</template>

<script>
export default {
    components: {

    }
};
</script>

<style scoped>
.spinnerText {
    margin-left: 15px;
}
</style>